"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
/**
 * Gets the base-64 encoded version of the OTP code.
 *
 * @param code Code string
 * @returns base64 encoded
 */
function getOTPAuthorizationCode(code) {
    return Buffer.from("".concat(code), 'ascii').toString('base64');
}
var isAuthError = function (err) {
    return (err === null || err === void 0 ? void 0 : err.name) === 'AuthError';
};
var AuthAPI = /** @class */ (function () {
    function AuthAPI(client, guestAudience) {
        this.client = client;
        this.guestAudience = guestAudience;
    }
    AuthAPI.prototype.registerSession = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var response, err_1;
            var locationId = _b.locationId, utm = _b.utm;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.post('/auth/session', { locationId: locationId, utm: utm })];
                    case 1:
                        response = _c.sent();
                        return [2 /*return*/, { data: response }];
                    case 2:
                        err_1 = _c.sent();
                        return [2 /*return*/, { error: 'Error registering session' }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthAPI.prototype.sendCode = function (phone, locationId, contactMethod) {
        return __awaiter(this, void 0, void 0, function () {
            var res, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.post('/auth/verify', {
                                phone: phone,
                                locationId: locationId,
                                contactMethod: contactMethod !== null && contactMethod !== void 0 ? contactMethod : 'TEXT',
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, {
                                data: res,
                            }];
                    case 2:
                        err_2 = _a.sent();
                        return [2 /*return*/, {
                                error: 'Could not send code',
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sends a register request to the server. You probably don't want to use this
     * directly. Instead, use `useCustomerControl` so we keep track of the
     * returned CSRF token.
     *
     * @param params Register request params
     * @param params.phone User phone number
     * @param params.code Verification code
     * @param params.utm User UTM attributes
     * @param params.email User email
     * @param params.firstName User first name
     * @param params.lastName User last name
     * @param params.referralId User referral ID
     * @param options Request options
     * @param options.csrf CSRF to pass (optional - for mobile only)
     * @returns registration response or error
     */
    AuthAPI.prototype.register = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b, options) {
            var headers, data, err_3, errRes;
            var _c, _d;
            var phone = _b.phone, code = _b.code, utm = _b.utm, email = _b.email, firstName = _b.firstName, lastName = _b.lastName, referralId = _b.referralId;
            if (options === void 0) { options = {}; }
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!code) {
                            throw new Error('expected register request to include code');
                        }
                        headers = {
                            Authorization: "Otp ".concat(getOTPAuthorizationCode(code)),
                        };
                        if (options === null || options === void 0 ? void 0 : options.csrf) {
                            headers['X-CSRFToken'] = options.csrf;
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.client.post('/auth/register', {
                                phone: phone,
                                utm: utm,
                                email: email,
                                firstName: firstName,
                                lastName: lastName,
                                referralId: referralId,
                            }, {
                                headers: headers,
                            })];
                    case 2:
                        data = _e.sent();
                        return [2 /*return*/, {
                                data: data,
                            }];
                    case 3:
                        err_3 = _e.sent();
                        if (axios_1.default.isAxiosError(err_3)) {
                            errRes = (_c = err_3.response) === null || _c === void 0 ? void 0 : _c.data;
                            if (((_d = err_3.response) === null || _d === void 0 ? void 0 : _d.status) === 401 && isAuthError(errRes)) {
                                return [2 /*return*/, {
                                        error: errRes,
                                    }];
                            }
                        }
                        throw err_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sends a guest login request to the server. You probably don't want to use
     * this directly. Most of the time, this is called indirectly by
     * the client returned by `useAuthenticatedClient` to start an unauthenticated
     * session.
     *
     * @returns registration response or error
     */
    AuthAPI.prototype.guestLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.post('/auth/login', undefined, {
                            headers: {
                                'X-PB-Audience': this.guestAudience,
                            },
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AuthAPI.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.post('/auth/logout', undefined)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sends a login request to the server. You probably don't want to use this
     * directly. Instead, use `useCustomerControl` so we keep track of the
     * returned CSRF token.
     *
     * @param code Verification code
     * @param options Login options
     * @param options.csrf Optional token if verify CSRF token is not a cookie
     * @returns registration response or error
     */
    AuthAPI.prototype.login = function (code_1) {
        return __awaiter(this, arguments, void 0, function (code, options) {
            var headers, data, err_4, errRes;
            var _a, _b;
            if (options === void 0) { options = {}; }
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        headers = {
                            Authorization: "Otp ".concat(getOTPAuthorizationCode(code)),
                        };
                        if (options === null || options === void 0 ? void 0 : options.csrf) {
                            headers['X-CSRFToken'] = options.csrf;
                        }
                        return [4 /*yield*/, this.client.post('/auth/login', undefined, {
                                headers: headers,
                            })];
                    case 1:
                        data = _c.sent();
                        return [2 /*return*/, {
                                data: data,
                            }];
                    case 2:
                        err_4 = _c.sent();
                        if (axios_1.default.isAxiosError(err_4)) {
                            errRes = (_a = err_4.response) === null || _a === void 0 ? void 0 : _a.data;
                            if (((_b = err_4.response) === null || _b === void 0 ? void 0 : _b.status) === 401 && isAuthError(errRes)) {
                                return [2 /*return*/, {
                                        error: errRes,
                                    }];
                            }
                        }
                        throw err_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return AuthAPI;
}());
exports.default = AuthAPI;
//# sourceMappingURL=index.js.map